import { useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import {endPoints} from "./../../../apis";
import apiRequest from "./../../../apiRequest";

function Basic() {
  const [email, setEmail] = useState(""); 
  const [password, setPassword] = useState(""); 
  const [error, setError] = useState(""); 
  const [loading, setLoading] = useState(false); 
  const navigate = useNavigate(); 

  // Function to handle login
  const handleLogin = async (e) => {
    e.preventDefault();
    setError(""); // Reset error state
    setLoading(true); // Show loading spinner
  
    try {
      const payload = {
        email: email, // Corrected this to use `email` instead of `username`
        password: password,
      };
  
      await apiRequest.post(
        `${endPoints.AUTH_LOGIN}`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      ).then((response) => {
        if (response.success) {
          localStorage.setItem('email', response.data.email);
          localStorage.setItem('access_token', response.data.access_token);
          navigate('/dashboard');
        } else {
          setError(response.message || 'Invalid credentials');
        }
      }).catch((error) => {
        setError(error.message || 'An error occurred');
      });
    } catch (err) {
      console.log(err);
      setError(err.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleLogin}>
            <MDBox mb={2}>
              <MDInput
                type="email"
                label="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                fullWidth
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                fullWidth
              />
            </MDBox>
            {error && (
              <MDTypography variant="caption" color="error">
                {error}
              </MDTypography>
            )}
            <MDBox mt={4} mb={1}>
              <MDButton type="submit" variant="gradient" color="info" fullWidth disabled={loading}>
                {loading ? "Signing in..." : "Sign in"}
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
